var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-72, -232)",
    fill: "#7A858E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(72, 232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,17.75 C10.3080937,17.75 10.1160936,17.6767578 9.96984351,17.5302734 C9.67687476,17.2373047 9.67687476,16.7626953 9.96984351,16.4697266 L13.9406251,12.5 L9.96984351,8.53039074 C9.67687476,8.23742199 9.67687476,7.76281261 9.96984351,7.46984386 C10.2628123,7.17687511 10.7374216,7.17687511 11.0303904,7.46984386 L15.5303904,11.9698439 C15.8233591,12.2628126 15.8233591,12.737422 15.5303904,13.0303907 L11.0303904,17.5303907 C10.8843745,17.6773436 10.6921867,17.75 10.4999993,17.75 L10.5,17.75 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.de958b1c85e47c484e0ceb04c9158bc6.svg";
export { ForwardRef as ReactComponent };